export default __webpack_public_path__ + "static/media/close_icon.74d0fc87.svg";